import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  FaPhone,
  FaEnvelope,
  FaClock,
  FaCalendarAlt,
  FaUser,
  FaComments,
} from "react-icons/fa";

const Contact = ({ isHome }) => {
  const [formData, setFormData] = useState({
    name: "",
    preferredDate: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

  const phoneNumber = process.env.REACT_APP_PHONE_NUMBER; // <-- WhatsApp number in international format
  console.log("Phone Number:", phoneNumber);
  let message = "";

  if (formData.message.trim() !== "") {
    // User typed a custom message → include it, plus name/date if available
    message = `${formData.message}`;

    if (formData.name.trim() !== "") {
      message += `\nNom: ${formData.name}`;
    }

    if (formData.preferredDate.trim() !== "") {
      message += `\nDate préférée: ${formData.preferredDate}`;
    }
  } else {
    // No custom message → send default template
    message = `Bonjour, je veux prendre un rendez-vous pour une consultation.`;
    if (formData.name.trim() !== "") {
      message += `\nNom: ${formData.name}`;
    }
    if (formData.preferredDate.trim() !== "") {
      message += `\nDate préférée: ${formData.preferredDate}`;
    }
  }

  const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );

    // Optional: reset form after sending
    setFormData({
      name: "",
      preferredDate: "",
      message: "",
    });
  };

  const contactInfo = [
    {
      icon: <FaClock className="text-2xl text-primary-500" />,
      title: "Horaires",
      details: [
        "Lun-Ven : 9h00 - 19h00",
        "Sam : 9h00 - 14h00",
        "Urgence : 24h/24 7j/7",
      ],
      action: "Voir les horaires",
    },
    {
      icon: <FaPhone className="text-2xl text-primary-500" />,
      title: "Contact",
      details: ["☎️ 05 38 44 44 45", "📱 07 08 44 44 54"],
      action: "Appeler maintenant",
    },
    {
      icon: <FaEnvelope className="text-2xl text-primary-500" />,
      title: "Email",
      details: ["drlachhab.youssef@gmail.com"],
      action: "Envoyer un email",
    },
  ];

  return (
    <>
      {!isHome && (
        <Helmet>
          <title>Contact – Cabinet Dentaire Temara</title>
          <meta
            name="description"
            content="Prenez contact avec le Cabinet Dentaire Temara à Temara. Téléphone, WhatsApp pour vos rendez-vous, urgences dentaires et questions sur nos services."
          />
          <meta
            property="og:title"
            content="Contact – Cabinet Dentaire Temara"
          />
          <meta
            property="og:description"
            content="Contactez-nous dès aujourd'hui pour prendre rendez-vous, poser vos questions ou pour les urgences dentaires 24h/24 et 7j/7."
          />
          <meta
            property="og:image"
            content="https://centredentairetemara.ma/images/logo_horizontal_no_background.png"
          />
          <meta
            property="og:url"
            content="https://centredentairetemara.ma/contact"
          />
          <meta property="og:type" content="website" />
        </Helmet>
      )}
      <section id="contact" className="section-padding bg-gray-50 pt-24">
        <div className="container-custom">
          {/* Header */}
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Prenez <span className="text-gradient">Contact</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Prêt à transformer votre sourire ? Contactez-nous dès aujourd'hui
              pour prendre rendez-vous ou poser vos questions sur nos services.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div data-aos="fade-right">
              <h3 className="text-2xl font-bold text-gray-800 mb-8">
                Informations <span className="text-gradient">de Contact</span>
              </h3>

              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl p-6 shadow-lg card-hover"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">{info.icon}</div>
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-800 mb-2">
                          {info.title}
                        </h4>
                        <div className="space-y-1">
                          {info.details.map((detail, detailIndex) => {
                            const isUrgence = detail
                              .toLowerCase()
                              .includes("urgence");
                            return (
                              <p
                                key={detailIndex}
                                className={`${
                                  isUrgence
                                    ? "text-red-500 font-semibold"
                                    : "text-gray-600"
                                }`}
                              >
                                {detail}
                              </p>
                            );
                          })}
                        </div>
                        {info.title === "Horaires" && (
                          <a
                            href="https://www.instagram.com/stories/highlights/18519802939030031/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-600 font-medium hover:text-primary-700 transition-colors duration-300 mt-2 inline-block"
                          >
                            {info.action}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 bg-white rounded-xl shadow-lg overflow-hidden">
                <iframe
                  title="Notre Emplacement"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.860007881115!2d-6.906179999999999!3d33.91900239999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda713042f4be93f%3A0xd4b4a3b516b09c42!2sCabinet%20Dentaire%20Dr%20Youssef%20Lachhab!5e0!3m2!1sen!2sma!4v1756034391004!5m2!1sen!2sma"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Appointment Form */}
            <div data-aos="fade-left">
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="flex items-center space-x-3 mb-6">
                  <FaCalendarAlt className="text-2xl text-primary-500" />
                  <h3 className="text-2xl font-bold text-gray-800">
                    Prenez <span className="text-gradient">Rendez-vous</span>
                  </h3>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        <FaUser className="inline mr-2" />
                        Nom complet *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300"
                        placeholder="Entrez votre nom complet"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        <FaCalendarAlt className="inline mr-2" />
                        Date préférée
                      </label>
                      <input
                        type="date"
                        name="preferredDate"
                        value={formData.preferredDate}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      <FaComments className="inline mr-2" />
                      Message additionnel
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="4"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300"
                      placeholder="Parlez-nous de vos préoccupations dentaires ou toute demande particulière..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full btn-primary text-lg py-4"
                  >
                    Envoyer via WhatsApp
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <p className="text-sm text-gray-600">
                    * Champs obligatoires. Nous vous contacterons sous 24h pour
                    confirmer votre rendez-vous.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Emergency Contact */}
          <div className="mt-16 text-center" data-aos="fade-up">
            <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">🚨 Urgence dentaire ?</h3>
              <p className="text-lg mb-6 opacity-90">
                N'attendez pas ! Appelez notre ligne d'urgence immédiatement
                pour des soins dentaires urgents.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <button className="bg-white text-red-600 font-bold py-4 px-8 rounded-lg text-xl hover:bg-gray-100 transition-colors duration-300">
                  Urgence : 07 08 44 44 54
                </button>
                <p className="text-sm opacity-75">
                  Soins d'urgence disponibles 24h/24 et 7j/7
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
